import { CANCEL, SETUP_MFA_GENERIC_ERROR } from '../../constants/ui.labels'
import mapError from '../../utils/mapError'
import ActionButton from '../ActionButton'
import ContentHeader from '../ContentHeader'
import Error from '../Error'
import Box from '@talkdesk/cobalt-react-box'
import Link from '@talkdesk/cobalt-react-link'
import Button from '@talkdesk/cobalt-react-button'
import Flex from '@talkdesk/cobalt-react-flex'
import Grid, { Column } from '@talkdesk/cobalt-react-grid'

/** @param {{ title?: any, subtitle?: any, footnoteLabel?: any, footnoteUrl?: any, boxContent?: any, onCancel?: any, isProcessing?: any, buttonAction?: any, buttonDisabled?: any, buttonLabel?: any, errorCode?: any, children?: any }} props */
const SetupMFAStep = ({
  title,
  subtitle,
  footnoteLabel,
  footnoteUrl,
  boxContent,
  onCancel,
  isProcessing,
  buttonAction,
  buttonDisabled,
  buttonLabel,
  errorCode,
  children,
}) => {
  const errorMessage = errorCode
    ? mapError(errorCode, SETUP_MFA_GENERIC_ERROR)
    : undefined

  return (
    <Flex direction='column' alignX='center' alignY='center'>
      <ContentHeader title={title} message={subtitle} />
      <Error message={errorMessage} />
      <Box width='100%'>{boxContent}</Box>
      <Flex padding={['3', '5', '6']} alignX='center'>
        <Link target='_blank' href={footnoteUrl}>
          {footnoteLabel}
        </Link>
      </Flex>
      <Box paddingY='10' width='100%'>
        <form
          onSubmit={(event) => {
            event.preventDefault()
            if (buttonDisabled || isProcessing) {
              return
            }
            buttonAction()
          }}
        >
          <Box width='100%'>
            {children ? <>{children}</> : null}
            <Box width='100%'>
              <Grid columns='3' gap='2'>
                <Column length='1'>
                  <Button
                    htmlType='button'
                    shape='full-width'
                    type='secondary'
                    onClick={onCancel}
                  >
                    {CANCEL}
                  </Button>
                </Column>
                <Column length='2'>
                  <ActionButton
                    shape='full-width'
                    htmlType='submit'
                    isProcessing={isProcessing}
                    isDisabled={buttonDisabled}
                  >
                    {buttonLabel}
                  </ActionButton>
                </Column>
              </Grid>
            </Box>
          </Box>
        </form>
      </Box>
    </Flex>
  )
}

export default SetupMFAStep
